import { render, staticRenderFns } from "./Customer_product_all.vue?vue&type=template&id=53827864&scoped=true&"
import script from "./Customer_product_all.vue?vue&type=script&lang=js&"
export * from "./Customer_product_all.vue?vue&type=script&lang=js&"
import style0 from "./Customer_product_all.vue?vue&type=style&index=0&id=53827864&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53827864",
  null
  
)

export default component.exports